import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download_list",
  "use": "download_list-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"download_list\"><g fill-rule=\"evenodd\"><path d=\"M10 12.71l-2.35-2.36.7-.7 1.15 1.14V7.75h1v3.04l1.15-1.14.7.7L10 12.71zM10 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z\" /><path d=\"M1 11V1h8v4.1c.32-.07.66-.1 1-.1V0H0v12h5.41c-.13-.32-.24-.65-.31-1H1z\" /><path d=\"M2 3h6V2H2zM2 6h6V5H2zM2 9h3V8H2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id